module.exports = __webpack_public_path__ + "img/Secure-Chat.e67575ff.png";